import { isValidPhoneNumber } from 'react-phone-number-input';

export const emailIsValid = (email: string): boolean =>
  /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]+)$/.test(email);

export const phoneNumberIsValid = (phoneNumber: string): boolean => isValidPhoneNumber(phoneNumber);
